import { ICellRendererAngularComp } from "@ag-grid-community/angular";
import { ICellRendererParams } from "@ag-grid-community/core";
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from "@angular/core";
import { History } from "@front/m19-api-client";
import { IButtonDirective, IIconComponent, ModalService, ToasterService } from "@front/m19-ui";
import { TranslocoDirective, TranslocoService } from "@jsverse/transloco";
import {
  ModalActivityCommentComponent,
  ModalActivityCommentData,
} from "../modal-activity-comment/modal-activity-comment.component";

@Component({
  template: ` <ng-container *transloco="let t">
    @if (!history.comment) {
      <button iButton variant="ghost" size="xs" (click)="updateHistoryComment()" [disabled]="readonly">
        <IIcon name="edit" />
      </button>
    } @else {
      <button iButton variant="ghost" size="xs" (click)="updateHistoryComment()" [disabled]="readonly">
        {{ history.comment }}
        <IIcon name="edit" />
      </button>
    }
  </ng-container>`,
  imports: [IButtonDirective, TranslocoDirective, IIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivityCommentComponent implements ICellRendererAngularComp {
  private toasterService = inject(ToasterService);
  private modalService = inject(ModalService);
  private translocoService = inject(TranslocoService);

  @Input({ required: true })
  history!: History;
  @Input({ required: true })
  readonly!: boolean;
  @Output()
  commentUpdate = new EventEmitter<string>();

  agInit(params: ICellRendererParams<History> & { readonly: boolean; commentUpdate: (comment: string) => void }) {
    this.history = params.data!;
    this.readonly = params.readonly;
    this.commentUpdate.subscribe((comment) => params.commentUpdate(comment));
  }

  refresh(): boolean {
    return false;
  }

  updateHistoryComment() {
    if (this.readonly) {
      return;
    }

    const modalRef = this.modalService.openModal<ModalActivityCommentData, string>(ModalActivityCommentComponent, {
      size: "md",
      modalTitle: this.translocoService.translate("modal-activity-comment.add_comment"),
      data: {
        history: this.history,
      },
    });

    modalRef.afterClosed().subscribe((comment) => {
      this.toasterService.success("Activity update", "Successfully updated activity");
      this.commentUpdate.emit(comment);
    });
  }
}
